import { render, staticRenderFns } from "./SideBarItem.vue?vue&type=template&id=783199a0&scoped=true&"
import script from "./SideBarItem.vue?vue&type=script&lang=js&"
export * from "./SideBarItem.vue?vue&type=script&lang=js&"
import style0 from "./SideBarItem.vue?vue&type=style&index=0&id=783199a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783199a0",
  null
  
)

export default component.exports